import { Component } from "@angular/core"
import { RouterOutlet } from "@angular/router"

@Component({
	selector: "app-layout-empty",
	imports: [RouterOutlet],
	templateUrl: "./main.html"
})
export class LayoutEmpty {}
